import PropTypes from 'prop-types';

import { SectionAlternate } from '@/src/components/organisms';

import { SliceZone, FooterNewsletter } from './components';

export default function PlatformDetails({ doc }) {
  return (
    <>
      <SliceZone slices={doc.data?.body || []} />
      <SectionAlternate>
        <FooterNewsletter />
      </SectionAlternate>
    </>
  );
}

PlatformDetails.propTypes = {
  doc: PropTypes.object,
};
